import './src/styles.css'
// 미리보기 토큰. 전역으로 싣지만 규칙이 전부 body.preview-tokens 하위라,
// 클래스가 붙지 않은 화면에는 아무 영향이 없다.
// 2026-09-08 이관 후 파일은 비어 있다 — 장치만 남겼다(README "이관 후에도 남기는 것").
// 다음에 값을 바꿔볼 때 그 파일에 규칙만 추가하면 ?preview 로 바로 비교할 수 있다.
import './src/preview/tokens.css'

// SPA 라우팅 시에도 SSR과 동일하게 blog 경로만 밝은 GNB 유지
export const onRouteUpdate = ({ location }) => {
  document.body.classList.toggle('has-dark-hero', !location.pathname.includes('/blog'))

  // 미리보기 토글.
  //   ?preview     — 아무 페이지에서나. 복제하지 않고 바뀐 값을 확인하는 용도
  //   /preview/*   — 그런 경로를 다시 만들면 항상 켜진다
  //                  (지금은 그런 페이지가 없어 이 조건은 쉬고 있다. gatsby-ssr.js 와 한 쌍)
  const previewTokens =
    location.pathname.startsWith('/preview/') ||
    new URLSearchParams(location.search).has('preview')
  document.body.classList.toggle('preview-tokens', previewTokens)
}
